import React from 'react';
import { Link } from 'react-router-dom';
export function Header() {
  return <header className="bg-white shadow-sm" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-38">
        <div className="flex justify-between items-center" data-id="element-39">
          <Link to="/" className="text-2xl font-bold text-[#0A1D37]" data-id="element-40">
            Forgepoint Management LLC
          </Link>
          <nav className="hidden md:block" data-id="element-41">
            <ul className="flex space-x-8" data-id="element-42">
              <li data-id="element-43">
                <Link to="/" className="text-gray-600 hover:text-[#10B981]" data-id="element-44">
                  Home
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/privacy-policy" className="text-gray-600 hover:text-[#10B981]" data-id="element-46">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/sms-policy" className="text-gray-600 hover:text-[#10B981]" data-id="element-48">
                  SMS Policy
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>;
}